import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { isNilOrEmpty, isObject } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import useControlNext from '@gef-ui/form-core/hooks/state/useControlNext';
import useFormData from '@gef-ui/form-core/hooks/state/useFormData';
import { setValue } from '@gef-ui/form-core/stream/transfer/control';

import Agency from 'components/atoms/GefMui/OrganizationStructure/Agency';
import Region from 'components/atoms/GefMui/OrganizationStructure/Region';
import { USER_ROLES } from 'constants/general';
import { fetchContactOrder } from 'features/views/campaignDashboards/order/actions';
import { FIELDS, ORDER_FORM_NAME } from 'features/views/campaignDashboards/order/form';
import { getCurrentRole } from 'features/views/user/selectors';

export const Filter = ({ campaign }) => {
	const dispatch = useDispatch();
	const currentRole = useSelector(getCurrentRole);
	const next = useControlNext(ORDER_FORM_NAME);
	const formData = useFormData();
	const formIsInitiated = isObject(formData);

	useEffect(() => {
		if (formIsInitiated && isNilOrEmpty(formData?.channel)) {
			next(setValue({ fieldName: FIELDS.channel, value: campaign?.channelId }));
		}
	}, [formIsInitiated, next, formData?.channel, campaign?.channelId]);

	const handleLoadOrders = useCallback(() => {
		dispatch(fetchContactOrder(campaign?.id));
	}, [dispatch, campaign.id]);

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container spacing={2}>
					<Grid size={1} />
					<Grid size={5}>
						<Region
							fieldName={FIELDS.region}
							formName={ORDER_FORM_NAME}
							disableOnOneOptions
							autoSelect
							campaignId={currentRole === USER_ROLES.GUARANTOR && campaign ? campaign.id : null}
							onChange={handleLoadOrders}
						/>
					</Grid>
					<Grid size={5}>
						<Agency
							fieldName={FIELDS.agency}
							formName={ORDER_FORM_NAME}
							disableOnOneOptions
							autoSelect
							onChange={handleLoadOrders}
						/>
					</Grid>
					<Grid size={1} />
				</Grid>
			</Grid>
		</Grid>
	);
};

Filter.propTypes = {
	campaign: PropTypes.object,
};

export default Filter;
